import { motion } from "framer-motion";
import { useAiStudio } from "@/hooks/useAiStudio";
import { AiControls } from "./ai/AiControls";
import { AiResult } from "./ai/AiResult";
import { AiGallery } from "./ai/AiGallery";

export const AiStudio = ({ onQuote }) => {
  const studio = useAiStudio(onQuote);
  return <section id="atelier-ia" className="relative py-20 sm:py-28 overflow-hidden" data-testid="ai-studio-section">
    <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(700px circle at 50% 30%, rgba(236,72,153,0.22), transparent 70%)" }} />
    <div className="max-w-6xl mx-auto px-5 sm:px-8 relative">
      <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.2 }} transition={{ duration: 0.75 }}>
        <p className="font-mono-ui text-[11px] uppercase text-pink-400 mb-4" data-testid="ai-provider-label">Studio IA — Nano Banana 2 · Mammouth</p>
        <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-none">Imagine ton <span className="text-pink-500" style={{ textShadow: "0 0 30px rgba(236,72,153,0.5)" }}>chef-d'œuvre</span></h2>
        <p className="mt-4 max-w-2xl text-slate-300 text-base sm:text-lg leading-relaxed">Décris ton idée, choisis la surface et le style : l'IA peint un aperçu gratuit de ton futur graffiti. Ensuite, demande un croquis pour le faire exister pour de vrai.</p>
      </motion.div>
      <div className="mt-10 grid lg:grid-cols-2 gap-8 items-stretch"><AiControls {...studio} /><AiResult {...studio} /></div>
      <AiGallery gallery={studio.gallery} />
    </div>
  </section>;
};